/**
 * DepartmentAutonomyPanel — Sprint 7 · Project Symphony
 *
 * "Departments now self-assign work." Rows are derived from actual
 * workspace state — never fabricated.
 */
import { Card } from "@/shared/ui/card";
import { Badge } from "@/shared/ui/badge";
import type { DepartmentAutonomyRow } from "../api";

export function DepartmentAutonomyPanel({
  rows,
}: {
  rows: DepartmentAutonomyRow[];
}): JSX.Element {
  return (
    <Card className="p-4 sm:p-6" data-testid="department-autonomy-panel">
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
        Department Autonomy
      </p>
      <ul className="divide-y divide-border">
        {rows.map((row) => (
          <li
            key={row.key}
            className="grid min-w-0 grid-cols-1 items-start gap-1 py-3 sm:grid-cols-[11rem_minmax(0,1fr)_auto] sm:items-center sm:gap-x-3"
            data-testid={`autonomy-row-${row.key}`}
          >
            <span className="min-w-0 text-sm font-semibold">{row.label}</span>
            <span className="min-w-0 break-words text-sm leading-relaxed text-muted-foreground">{row.activity}</span>
            <Badge
              variant={row.status === "active" ? "default" : "outline"}
              className="mt-1 w-fit shrink-0 sm:col-start-3 sm:row-start-1 sm:mt-0"
              data-testid={`autonomy-status-${row.key}`}
            >
              {row.status === "active" ? "Active" : "Standby"}
            </Badge>
          </li>
        ))}
      </ul>
    </Card>
  );
}
